<script setup lang="ts">
import { SLUG_NEWS } from '~/constants'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'

const config = useRuntimeConfig()
const route = useRoute()

const brandNameCapitalized = StringUtils.capitalizeFirstCharacter(config.public.BRAND_NAME.toLowerCase())

const headings = {
  [`/${SLUG_NEWS.PAGE}`]: {
    h1: 'Cập nhật tin tức bóng đá quốc tế, tin thể thao mới nhất 24h qua'
  },
  [`/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.ALL}`]: {
    h1: `Tin tức tổng hợp tại ${brandNameCapitalized}`
  },
  [`/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.LO_DE_ONLINE}`]: {
    h1: `Lô đề ${brandNameCapitalized}`,
    h2: `Lô đề online mỗi ngày tại ${brandNameCapitalized}`
  },
  [`/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.BETTING_EXPERIENCE}`]: {
    h1: `Cập nhật kinh nghiệm cá cược mới nhất tại ${brandNameCapitalized}`
  }
}

const h1 = computed(() => headings[route.fullPath]?.h1)
const h2 = computed(() => headings[route.fullPath]?.h2)
</script>

<template>
  <div class="d-none">
    <h1 v-if="h1">{{ h1 }}</h1>
    <h2 v-if="h2">{{ h2 }}</h2>
  </div>
</template>
